import { initReactI18next } from 'react-i18next'
import i18n from 'i18next'
import zhHK from './locales/zh-HK.json'

i18n
  .use(initReactI18next)
  .init({
    resources: {
      'zh-HK': {
        translation: zhHK,
      },
    },
    lng: 'zh-HK', // 預設語言
    fallbackLng: 'zh-HK',
    interpolation: {
      escapeValue: false, // React already escapes values
    },
  })

export default i18n
